<template>
  <div class="top-bar" :class="{ focused }">
    <div class="resize" @mousedown="dragStart"></div>
    <template v-if="!loading">
      <div v-for="hint in hints" :key="hint.id">
        <EditorButton
          @click.native="selectHint(hint)"
          :class="{ active: tabPage === 'hints' && selectedHint.id === hint.id, highlight: selectedArticle !== null && !hint.invalid_url_rule && hint.url_matches, error: !!hint.error, ohm: hint.statements.length }"
          :content="hint.name" :visible="hint.name !== null" :hintID="hint.id" v-tippy>
          {{ hint|getHintName }}
        </EditorButton>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import EditorButton from './EditorButton'

export default {
  name: 'EditorHintBar',
  components: { EditorButton },
  inject: ['dragStart'],
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    hints: {
      required: true
    }
  },
  methods: {
    selectHint(hint) {
      this.$store.commit('editor/setTabPage', 'hints')
      this.$store.commit('hint/setSelectedHint', hint)
    }
  },
  computed: {
    ...mapState('article', {
      selectedArticle: state => state.selected,
    }),
    ...mapState('editor', {
      tabPage: state => state.tabPage,
      focused: state => state.focused,
    }),
    ...mapState('hint', {
      selectedHint: state => state.selected,
    }),
  }
}
</script>

<style lang="sass" scoped>
@use '../../styles/variables' as v

.top-bar
  .resize
    width: 100%
    height: 1px
    position: relative
    border-top: v.$ui-border

    &:after
      content: ""
      height: 8px
      width: 100%
      top: -3px
      position: absolute

  &:not(.focused) .resize
    cursor: ns-resize

  .tab-btn
    position: relative

    &:after
      content: ""
      position: absolute
      width: 100%
      left: 0
      bottom: -1px
      border-bottom: 2px solid transparent
      transition: border-color 0.1s ease

    &.active:after
      border-color: v.$sharp-blue
</style>
